import { motion } from 'framer-motion'
import { Link } from 'react-router'
import TrueTenentLogo from '/img/TrueTenant-heading.png'
import authPageImage from '/img/auth-page-image.webp'
import BlurText from '#app/components/BlurText'
import { fadeIn, prefersReducedMotion, slideUp } from '#app/utils/animations'
// import {UserType,getAuthConfig} from '#app/utils/auth-config.server'

interface AuthLayoutProps {
	children: React.ReactNode
	userType: string
	backgroundImage?: string
	heroText?: {
		line1: string
		line2: string
		line3?: string
	}
}

export function AuthLayout({
	children,
	userType,
	backgroundImage = authPageImage,
	heroText = { line1: 'Where', line2: 'Renting Feels Easy', line3: '' },
}: AuthLayoutProps) {
	const shouldAnimate = !prefersReducedMotion()

	return (
		<div className="h-screen w-full overflow-hidden bg-white">
			<div className="grid md:grid-cols-2 h-full">
				{/* ================= LEFT IMAGE (FIXED) ================= */}
				<div className="hidden md:block h-full">
					<div className="relative w-full h-full">
						{/* Logo */}
						<motion.div
							className="absolute z-20 top-[51px] left-[54px]"
							initial={shouldAnimate ? 'hidden' : false}
							animate={shouldAnimate ? 'visible' : false}
							variants={shouldAnimate ? fadeIn : undefined}
							transition={{ delay: 0.2 }}
						>
							<Link to="/">
								<img
									alt="TrueTenant Logo"
									src={TrueTenentLogo}
									className="w-[318px]"
								/>
							</Link>
						</motion.div>

						{/* Hero Text */}
						<motion.div
							className={`absolute z-30 ${userType === 'tenant' ? 'bottom-[158px] left-[74px]' : 'top-[200px] left-[74px]'}`}
							initial={shouldAnimate ? 'hidden' : false}
							animate={shouldAnimate ? 'visible' : false}
							variants={shouldAnimate ? slideUp : undefined}
							transition={{ delay: 0.4 }}
						>
							<div className="flex flex-col">
								<BlurText
									text={heroText.line1}
									delay={150}
									animateBy="words"
									direction="top"
									animationFrom={undefined}
									animationTo={undefined}
									onAnimationComplete={undefined}
									className="text-[#32302F] text-[18px] capitalize mb-2"
								/>
								<BlurText
									text={heroText.line2}
									delay={150}
									animateBy="words"
									direction="top"
									animationFrom={undefined}
									animationTo={undefined}
									onAnimationComplete={() => {
										console.log('Animation completed!')
									}}
									className="text-[#32302F] text-[32px] font-semibold capitalize"
								/>
								{/* {userType == 'landlord' && <BlurText
									text="Into Effortless Living"
									delay={150}
									animateBy="words"
									direction="top"
									animationFrom={undefined}
									animationTo={undefined}
									onAnimationComplete={() => {
										console.log('Animation completed!')
									}}
									className="text-[#32302F] text-[32px] font-semibold capitalize"
								/>} */}
								{userType === 'landlord' && (
									<BlurText
										text={heroText.line3}
										delay={150}
										animateBy="words"
										direction="top"
										animationFrom={undefined}
										animationTo={undefined}
										onAnimationComplete={() => {
											console.log('Animation completed!')
										}}
										className="text-[#32302F] text-[32px] font-semibold capitalize"
									/>
								)}
							</div>
						</motion.div>

						{/* Background Image */}
						<div className="absolute inset-x-0 bottom-[15px] left-[15px] top-[15px] overflow-hidden rounded-[24px]">
							<motion.img
								src={backgroundImage}
								alt="Auth Background"
								className="
			w-full h-full
			object-cover
			object-left
		"
							/>
						</div>
					</div>
				</div>

				{/* ================= RIGHT FORM (SCROLLABLE) ================= */}
				<div className="relative h-full overflow-hidden">
					<div className="h-full overflow-y-auto overscroll-contain">
						<div className="min-h-full md:flex items-center justify-center py-10">
							{children}
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
